import { render, staticRenderFns } from "./SubCategoriesTable.vue?vue&type=template&id=473262a4&scoped=true&"
import script from "./SubCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoriesTable.vue?vue&type=style&index=0&id=473262a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473262a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSimpleTable,VSwitch,VTextField})
